import React, { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from "../Accordion/Accordion";
import EmptyLiabilities from "../EmptyLiabilities/EmptyLiabilities";
import ExtractBar from "../ExtractBar/ExtractBar";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import unsortedIcon from "../../assets/images/png/upDown.png";
import { observer } from "mobx-react-lite";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import {
  downloadPDFFile,
  exportExcel,
  getCurrentDate,
  getDisplayDate,
  getExcelNumData,
  getMonthforLiabShow,
  getPrintDate,
  getReportDetails,
  isShowData,
  numWithUnit,
  //printDocument,
  //trackEventWithScreen,
} from "../../utils/functions";
//import PdfTable from "../PdfTable/PdfTable";
import SortTable from "../../utils/Hooks/SortTable";
import UserStore from "../../store/UserStore";
import { useEffect } from "react";
import {
  accordionTableHeaderData,
  liabilityAccordionRow,
} from "../../utils/constants";
//import { LIABILITTIES, PORTFOLIO_PAGE } from "../../utils/constants";

const DataValue = ({ className, value }) => {
  return (
    <div className={`asset_class_wrapper ${className || ""}`}>
      <p className="asset_class_text">{value}</p>
    </div>
  );
};

const TableData = ({ styleObj, rowData, valueKey, isNum }) => {
  return (
    <td className="accordion_table_data_row_td" style={styleObj}>
      {isNum ? (
        <DataValue
          className={"font-roboto"}
          value={numWithUnit(
            rowData?.[valueKey]?.value,
            rowData?.[valueKey]?.value_type,
          )}
        />
      ) : (
        <DataValue value={rowData?.[valueKey]} />
      )}
    </td>
  );
};

const investedValueCellRenderer = (data, key) => {
  switch (key) {
    case "month":
      return (
        <p className="invested_value_cell">
          <p>{getMonthforLiabShow[data.month]}</p>{" "}
        </p>
      );
    case "outstanding_amount":
      return (
        <p className="invested_value_cell font-roboto">
          <p style={{ paddingRight: "12px" }}>
            {numWithUnit(
              data.outstanding_amount.value,
              data.outstanding_amount.value_type,
            )}
          </p>
        </p>
      );
    case "interest_accured":
      return (
        <p className="invested_value_cell font-roboto">
          <p>
            {numWithUnit(
              data.interest_accured?.value,
              data.interest_accured?.value_type,
            )}
          </p>
        </p>
      );
    default:
      return (
        <p className="invested_value_cell">
          {numWithUnit(
            data.invested_value?.value,
            data.invested_value?.value_type,
          )}
        </p>
      );
  }
};

const columns = [
  {
    label: "Month",
    key: "month",
    sortable: true,
    cellRenderer: investedValueCellRenderer,
  },
  {
    label: "Outstanding Amount",
    key: "outstanding_amount",
    sortable: true,
    cellRenderer: investedValueCellRenderer,
  },
  {
    label: "Interest Accrued",
    key: "interest_accured",
    sortable: true,
    cellRenderer: investedValueCellRenderer,
  },
];

const LiabilitiesSummary = observer(({ hasData }) => {
  const [filteredColumn, setFilteredColumn] = useState("");
  const [currentOpenAccordion, setCurrentOpenAccordion] = useState("");

  const liabilitiesSummary =
    UserStore?.portfolio?.clientLiabilities?.outstandingLiabilities;
  const lasDetails = UserStore?.portfolio?.clientLas;
  const filteredLibraries =
    UserStore.isHydrated && liabilitiesSummary
      ? [...liabilitiesSummary?.componentsList]
      : [];

  const breakupList =
    UserStore.isHydrated && lasDetails
      ? [...lasDetails?.monthlybreakupList]
      : [];

  const {
    isAscending: isPerformanceAscending,
    key1: contentSortKey,
    arrData: liablitiesContentData,
    setKeyForOrdering: setContentOrder,
  } = SortTable(
    breakupList,
    {
      key1: "month",
    },
    true,
  );

  const { isAscending, key1, arrData, setKeyForOrdering } = SortTable(
    filteredLibraries,
    {
      key1: "name",
    },
    false,
  );

  const exportLiabilitiesColumns = [
    { label: "", key: "asset_class", showColumn: true },
    { label: "Sanctioned Limit", key: "sanctioned" },
    { label: "Outstanding Loan", key: "outstanding" },
    { label: "Avg Outstanding", key: "avg_outstanding" },
    { label: "Interest Accured", key: "interest_accured" },
    { label: "Interest Paid", key: "interest_paid" },
    { label: "EMI", key: "emi" },
    { label: "Tenure", key: "tenure" },
    { label: "Interest Rate", key: "interest_rate" },
    { label: "Date Of EMI", key: "date_emi" },
    { label: "Next Premuim Date", key: "next_premuim_date" },
  ];

  const liabilitiesExportData = liabilitiesSummary?.componentsList?.map(
    (item) => {
      return {
        asset_class: item.name,
        sanctioned: getExcelNumData(item?.sanctionedLimit_amount?.actual_value),
        outstanding: getExcelNumData(item?.amount?.actual_value),
        avg_outstanding: "",
        interest_accured: "",
        interest_paid: "",
        emi: "",
        tenure: "",
        interest_rate: "",
        date_emi: "",
        next_premuim_date: "",
      };
    },
  );

  let modifiedExcelData = [];
  liabilitiesExportData?.forEach((assetClass, index) => {
    modifiedExcelData.push({ ...assetClass, primary: true });

    if (index === 0) {
      lasDetails?.monthlybreakupList
        ?.slice()
        ?.reverse()
        ?.forEach((subAssetClass) => {
          let subAssetObj = {
            asset_class: getMonthforLiabShow[subAssetClass.month],
            sanctioned: "",
            outstanding: "",
            avg_outstanding: getExcelNumData(
              subAssetClass.outstanding_amount.actual_value,
            ),
            interest_accured: getExcelNumData(
              subAssetClass.interest_accured?.actual_value,
            ),
            interest_paid: "",
            emi: "",
            tenure: "",
            interest_rate: "",
            date_emi: "",
            next_premuim_date: "",
          };
          modifiedExcelData.push({ ...subAssetObj });
        });
    }
  });

  if (UserStore?.portfolio?.clientLiabilities) {
  }

  const handleFilter = (filterType, keyParam) => {
    setFilteredColumn(filterType);
    if (filterType === filteredColumn) {
      setFilteredColumn("");
    }

    if (keyParam === "name") {
      setKeyForOrdering(
        { key1: keyParam },
        keyParam === key1 ? !isAscending : false,
      );
    } else {
      setKeyForOrdering(
        { key1: keyParam, key2: "actual_value" },
        keyParam === key1 ? !isAscending : false,
      );
    }
  };

  const handleAccordion = (accoridonName, accordionContent) => {
    setCurrentOpenAccordion(accoridonName);
    if (accoridonName === currentOpenAccordion) {
      setCurrentOpenAccordion("");
    }
  };

  const rowRenderer = (eachRowData, index) => (
    <tr key={index}>
      {columns.map((column) => {
        if (column?.cellRenderer) {
          return (
            <td key={index}>{column?.cellRenderer(eachRowData, column.key)}</td>
          );
        } else {
          return <td key={index}>{eachRowData[column.key]}</td>;
        }
      })}
    </tr>
  );

  const handleSorting = (key) => {
    const sortKey = contentSortKey === key ? !isPerformanceAscending : false;
    const keysObj =
      key === "month"
        ? {
            key1: key,
          }
        : {
            key1: key,
            key2: "actual_value",
          };
    setContentOrder(keysObj, sortKey);
  };

  const headerRenderer = ({ label, key, sortable, classn }, index) => (
    <td key={index} className={classn && classn}>
      <div className="header_cell cursor blueTextColor">
        <button
          className="accordion-content-header-button"
          onClick={() => handleSorting(key)}
        >
          <p>{label}</p>
          {sortable && (
            <div className="accordion_table_header_child_icon">
              <img
                src={
                  isPerformanceAscending && contentSortKey === key
                    ? sortedIcon
                    : !isPerformanceAscending && contentSortKey === key
                      ? sortedAtoz
                      : contentSortKey !== key
                        ? unsortedIcon
                        : ""
                }
                alt=""
              />
            </div>
          )}
        </button>
      </div>
    </td>
  );

  useEffect(() => {
    // trackEventWithScreen({
    //   eventName: PORTFOLIO_PAGE,
    //   screenName: LIABILITTIES,
    // });
  }, []);

  if (Number(liabilitiesSummary?.total_outstanding?.value) !== 0) {
    return (
      <div className="liabilities_summary_outside">
        <ExtractBar
          extractExcel={() => {
            exportExcel({
              sheetname: "Liabilities Summary",
              columns: exportLiabilitiesColumns,
              data: modifiedExcelData,

              reportDetails: {
                ...getReportDetails(
                  UserStore?.exportDetails,
                  UserStore.userData,
                  UserStore.getData === "fam",
                ),
                date: getPrintDate(UserStore.asOfDate),
              },
              excelName: `Liability Assets - ${getCurrentDate()}`,
            });
          }}
          extractPdf={() => {
            // printDocument("liabilities", {
            //   name: "Liability Assets",
            // });

            return downloadPDFFile({
              headerName: "Liabilities Summary",
              fileId: "liabilities",
              name: "Liability Assets",
              columns: exportLiabilitiesColumns,
              data: modifiedExcelData,
            });
          }}
          title={"Liabilities Summary"}
        />

        <div className="liabilities_summary_data">
          <div className="liab_outstanding_value">
            <h2>
              <span className="span1">{"Total Outstanding"}</span>{" "}
              <span className="span2">
                {liabilitiesSummary?.total_outstanding?.value || "-"}{" "}
              </span>
              <span className="unitFont liabUnit" style={{ color: "#03002F" }}>
                {liabilitiesSummary?.total_outstanding?.value_type || ""}
              </span>
              <span className="span3">
                {" As on "}
                {getDisplayDate(
                  UserStore?.portfolio?.clientLiabilities?.as_of_date,
                ) || ""}
              </span>{" "}
            </h2>
          </div>
          <div className="lackvalue"></div>
          <table className="accordion_table liabilitiesData">
            <thead className="accordion_table_header">
              {accordionTableHeaderData?.map((header, index) => (
                <th
                  key={index}
                  aria-sort={
                    key1 === header.key
                      ? isAscending
                        ? "Ascending"
                        : "Descending"
                      : undefined
                  }
                  className="accordion_table_header_child"
                  style={{ width: header.width }}
                >
                  {header.sortable ? (
                    <button
                      className="header-button"
                      onClick={() => handleFilter(header.title, header.key)}
                    >
                      <p className="accordion_table_header_child_heading blueTextColor">
                        {header.title}
                      </p>
                      <div className="accordion_table_header_child_icon">
                        <img
                          src={
                            isAscending && key1 === header.key
                              ? sortedIcon
                              : !isAscending && key1 === header.key
                                ? sortedAtoz
                                : key1 !== header.key
                                  ? unsortedIcon
                                  : ""
                          }
                          alt=""
                        />
                      </div>
                    </button>
                  ) : (
                    <p className="accordion_table_header_child_heading blueTextColor">
                      {header.title}
                    </p>
                  )}
                </th>
              ))}
            </thead>
            <tbody className="accordion_table_data">
              <>
                {!!filteredLibraries && !!filteredLibraries.length ? (
                  arrData?.map((rowData) => {
                    if (
                      isShowData(
                        rowData?.amount?.actual_value,
                        rowData?.sanctionedLimit_amount?.actual_value,
                      )
                    )
                      return (
                        <>
                          <Accordion>
                            <AccordionHeader>
                              <>
                                {liabilityAccordionRow?.map((row) => (
                                  <TableData rowData={rowData} {...row} />
                                ))}
                                <td
                                  className="accordion_table_data_row_td"
                                  style={{ width: "8%" }}
                                >
                                  <div
                                    style={{
                                      display:
                                        rowData?.name !== "Home Loan"
                                          ? "block"
                                          : "none",
                                    }}
                                    className="accordion_down_btn portfolio_button_animation buttonBlueBorder"
                                    onClick={() =>
                                      handleAccordion(rowData.name)
                                    }
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "100%",
                                        borderRadius: 10,
                                      }}
                                      className="portfolio_button_animation"
                                    >
                                      {currentOpenAccordion === rowData.name ? (
                                        <svg
                                          width="13"
                                          height="8"
                                          viewBox="0 0 13 8"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M7.05629 2.77309L6.70312 2.42069L6.34996 2.77309L2.11351 7.00031L1.41023 6.29703L6.70312 1.00414L11.996 6.29703L11.2927 7.00031L7.05629 2.77309Z"
                                            stroke="#404040"
                                          />
                                        </svg>
                                      ) : (
                                        <svg
                                          width="13"
                                          height="8"
                                          viewBox="0 0 13 8"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M7.05629 5.23081L6.70312 5.58321L6.34996 5.23081L2.11351 1.0036L1.41023 1.70687L6.70312 6.99977L11.996 1.70688L11.2927 1.0036L7.05629 5.23081Z"
                                            stroke="#404040"
                                          />
                                        </svg>
                                      )}
                                    </span>
                                  </div>
                                </td>
                              </>
                            </AccordionHeader>
                            <AccordionContent
                              open={currentOpenAccordion === rowData.name}
                            >
                              <table className="table accordion_content_custom_table ">
                                <thead>
                                  <tr>{columns?.map(headerRenderer)}</tr>
                                </thead>
                                <tbody>
                                  {liablitiesContentData?.map(rowRenderer)}
                                </tbody>
                              </table>
                            </AccordionContent>
                          </Accordion>
                        </>
                      );
                    else return false;
                  })
                ) : (
                  <></>
                )}
              </>
            </tbody>
          </table>
        </div>
        {/* <PdfTable
          headerName={"Liabilities Summary"}
          columns={exportLiabilitiesColumns}
          data={modifiedExcelData}
          id="liabilities"
        /> */}
      </div>
    );
  } else {
    return (
      <div className="no_data_liabilites">
        <EmptyLiabilities
          message={"You do not have any liabilities with Nuvama to report"}
        />
      </div>
    );
  }
});

export default LiabilitiesSummary;
